import React from 'react';
import ReactDatePicker from 'react-datepicker';
import styled, { createGlobalStyle } from 'styled-components';
import { DateFilterContainer } from '../styled';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import { delimitDateString } from '../../utils/helpers';
import { constants, util, Text, Stack } from '@thecb/components';

const ReactDatePickerLabel = styled.label`
  font-size: 14px;
  font-weight: normal;
`;

const GlobalDatePickerStyles = createGlobalStyle`
  .react-datepicker__day--selected {
    background-color: ${constants.colors.LUCKY_POINT};
  }
`;

const DatePicker = ({
  field,
  fieldActions,
  id,
  label,
  fullWidth = false,
  errorTextVariant = 'pXS',
  showFieldErrorRow = true,
  showErrors,
  errorMessages,
  errorFieldExtraStyles = '',
  labelTextWhenNoError = '',
}) => {
  // redux-freeform expects a simple string ie "01072022" while react-datepicker expects a date object for the `selected` prop
  const formattedDate = delimitDateString(field.rawValue);
  const handleDateChangeRaw = (e) => {
    if (e.target.value === '') {
      // default react-datepicker behavior would assume a default date set upon leaving calendar focus.
      // this allows the user to backspace/clear the individual input value without clearing all other filters too
      fieldActions.set('');
    }
  };
  return (
    <DateFilterContainer
      fullWidth={fullWidth}
      $hasError={
        (field.hasErrors && field.dirty) || (field.hasErrors && showErrors)
      }
    >
      <GlobalDatePickerStyles />
      <ReactDatePickerLabel htmlFor={id}>{label}</ReactDatePickerLabel>
      <ReactDatePicker
        id={id}
        selected={formattedDate ? new Date(formattedDate) : formattedDate}
        onChange={(date) => fieldActions.set(dayjs(date).format('MMDDYYYY'))}
        dateFormat={'MM/dd/yyyy'}
        autoComplete="off"
        minDate={new Date('01/01/2022')}
        maxDate={new Date()}
        onChangeRaw={handleDateChangeRaw}
        popperModifiers={[
          {
            name: 'arrow',
            options: { padding: 10 },
          },
        ]}
      />
      {showFieldErrorRow && (
        <Stack
          direction="row"
          justify="space-between"
          aria-live="polite"
          aria-atomic={true}
        >
          {(field.hasErrors && field.dirty) ||
          (field.hasErrors && showErrors) ? (
            <Text
              color={constants.colors.ERROR_COLOR}
              variant={errorTextVariant}
              weight={'400'}
              extraStyles={`word-break: break-word;
              font-family: Public Sans;
              &::first-letter {
                text-transform: uppercase;
              }
              ${errorFieldExtraStyles};`}
              id={util.general.createIdFromString(
                labelTextWhenNoError,
                'error message',
              )}
            >
              {errorMessages[field.errors[0]]}
            </Text>
          ) : (
            <Text extraStyles={`height: 1rem;`} />
          )}
        </Stack>
      )}
    </DateFilterContainer>
  );
};

export default DatePicker;
